import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { RoughagePlusEnvironment } from 'src/environments/environment';

import {
  AgriculturalSampleTypes,
  SilageSoilSegment,
} from '../models/silage-soil-segments.model';
import {
  LabResultsResponse,
  NutrientDefinition,
} from './request-models/labresult.model';

@Injectable({
  providedIn: 'root',
})
export class SilageSoilService {
  private readonly http = inject(HttpClient);
  private readonly environment =
    inject<RoughagePlusEnvironment>(EnvironmentInjector);

  public getSilageSoilData(
    segment: SilageSoilSegment,
    searchTerm: string | null,
    pageSize = 25,
    pageNumber = 1,
  ): Observable<LabResultsResponse> {
    let params = new HttpParams({
      fromObject: {
        agriculturalSampleTypes: AgriculturalSampleTypes[segment],
        pageSize,
        pageNumber,
        sortDirection: 'Desc',
      },
    });

    if (searchTerm) {
      params = params.append('keyword', searchTerm);
    }

    if (segment === SilageSoilSegment.Soil) {
      params = params.append('includeAgriculturalSampleTypeNull', false);
    }

    return this.http.get<LabResultsResponse>(
      `${this.environment.APIM_BASE_URL}/labresult-v2-service/labresult-v2/lab-results`,
      {
        params,
      },
    );
  }

  public getNutrientDefinitions(): Observable<NutrientDefinition[]> {
    return this.http.get<NutrientDefinition[]>(
      `${this.environment.APIM_BASE_URL}/labresult-v2-service/labresult-v2/nutrients`,
    );
  }
}
